import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbItem } from './page-title.model';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent {

  @Input() breadcrumbItems: BreadcrumbItem[] = [];
  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() showButton: boolean | null = false;
  @Input() button: string = '';
  @Output() btnClick: EventEmitter<any> = new EventEmitter();

  constructor(public router: Router) { }


}
